<template>
  <div id="nav">
    <v-navigation-drawer v-model="sidebar" app temporary>
      <v-toolbar flat>
        <v-list>
          <v-list-tile>
            <v-list-tile-title class="title">
              {{ appTitle }}
            </v-list-tile-title>
            <v-spacer />
            <v-btn flat icon @click="sidebar = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-list-tile>
        </v-list>
      </v-toolbar>
      <v-list>
        <v-list-tile
          v-for="item in menuItems"
          :key="item.title"
          :to="item.path"
        >
          <v-list-tile-action>
            <v-badge v-if="item.numNotis !== undefined && item.numNotis !== 0" overlap left color="red">
              <template v-slot:badge>
                <span>{{ item.numNotis }}</span>
              </template>
              <v-icon>{{ item.icon }}</v-icon>
            </v-badge>
            <v-icon v-if="item.numNotis === undefined || item.numNotis === 0">{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>{{ item.title }}</v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="isAuthenticated" @click="userSignOut" class="signout" dark>
          <v-list-tile-action>
            <v-icon>exit_to_app</v-icon>
          </v-list-tile-action>
          <v-list-tile-content style="color: white;">Salir</v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar app>
      <span class="hidden-sm-and-up">
        <v-toolbar-side-icon @click="sidebar = !sidebar"> </v-toolbar-side-icon>
      </span>
      <v-toolbar-title>
        <router-link :to="titleLink" tag="span" style="cursor: pointer">
          {{ appTitle }}
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-xs-only">
        <v-menu v-if="isAuthenticated" offset-y open-on-hover>
          <template v-slot:activator="{ on }">
            <v-btn flat key="Panel" to="/dashboard" v-on="on">
              <v-icon left dark>dashboard</v-icon>
              Panel
            </v-btn>
          </template>
          <v-list>
            <v-list-tile key="1" to="/dashboard/sensors">
              <v-icon left light>security</v-icon>
              <v-list-tile-title>Sensores</v-list-tile-title>
            </v-list-tile>
            <v-list-tile key="2" to="/dashboard/groups">
              <v-icon left light>folder</v-icon>
              <v-list-tile-title>Grupos</v-list-tile-title>
            </v-list-tile>
            <v-list-tile key="3" to="/dashboard/buildings">
              <v-icon left light>location_city</v-icon>
              <v-list-tile-title>Edificios</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-btn v-if="isAuthenticated" flat key="Alertas" to="/notifications">
          <v-badge v-if="numNotis !== undefined && numNotis !== 0" overlap left color="red">
            <template v-slot:badge>
              <span>{{ numNotis }}</span>
            </template>
            <v-icon left dark>{{ notisIcon }}</v-icon>
          </v-badge>
          <v-icon v-if="numNotis === undefined || numNotis === 0" left dark>{{ notisIcon }}</v-icon>
          Alertas
        </v-btn>
        <v-btn v-if="!isAuthenticated" flat v-for="item in menuItems" :key="item.title" :to="item.path">
          <v-icon left dark>{{ item.icon }}</v-icon>

          {{ item.title }}
        </v-btn>
        <v-menu v-if="isAuthenticated" offset-y open-on-hover>
          <template v-slot:activator="{ on }">
            <v-btn flat key="Nuevo" to="/new" v-on="on">
              <v-icon left dark>add_box</v-icon>
              Nuevo
            </v-btn>
          </template>
          <v-list>
            <v-list-tile key="1a" to="/new/sensor">
              <v-icon left light>security</v-icon>
              <v-list-tile-title>Sensor</v-list-tile-title>
            </v-list-tile>
            <v-list-tile key="2a" to="/new/group">
              <v-icon left light>folder</v-icon>
              <v-list-tile-title>Grupo</v-list-tile-title>
            </v-list-tile>
            <v-list-tile key="3a" to="/new/building">
              <v-icon left light>location_city</v-icon>
              <v-list-tile-title>Edificio</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-menu v-if="isAuthenticated" offset-y open-on-hover>
          <template v-slot:activator="{ on }">
            <v-btn flat key="Perfil" :to="profileLink" v-on="on">
              <v-icon left dark>person</v-icon>
              Perfil
            </v-btn>
          </template>
          <v-list>
            <v-list-tile key="1b" to="/config/profile">
              <v-icon left light>edit</v-icon>
              <v-list-tile-title>Editar</v-list-tile-title>
            </v-list-tile>
            <v-list-tile key="2b" to="/config/account">
              <v-icon left light>settings</v-icon>
              <v-list-tile-title>Ajustes</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-btn v-if="isAuthenticated" @click="userSignOut" dark color="red">
          <v-icon left>exit_to_app</v-icon>
          Salir
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
  </div>
</template>

<script>
  import firebase from "firebase";

  let firebaseApp;
  if (!firebase.apps.length) {
    firebaseApp = firebase.initializeApp({
      apiKey: "AIzaSyBnuZJIuRvweJ_qX4ZEmQCe2cerF92RCz4",
      authDomain: "tfgr-9ed26.firebaseapp.com",
      databaseURL: "https://tfgr-9ed26.firebaseio.com",
      projectId: "tfgr-9ed26",
      storageBucket: "tfgr-9ed26.appspot.com",
      messagingSenderId: "47742064305"
    });
  } else {
    firebaseApp = firebase.app();
  }
  export const db = firebaseApp.database();

//Barra de navegación
// @group Interfaz extra
export default {
  name: "NavBar",
  data() {
    return {
      appTitles: "",
      sidebar: false
    };
  },
  created() {
    let iduser;
    if (this.$store.state.user !== null) {
      iduser = this.$store.state.user.uid;
    } else {
      iduser = "";
    }
    this.$bindAsArray(
      "notificaciones",
      db
        .ref("notifications")
        .orderByChild("dest")
        .equalTo(iduser)
    );
  },
  computed: {
    profileLink() {
      return "/profile?id=" + this.$store.state.user.uid;
    },
    // @vuese
    // Número de notificaciones sin leer
    numNotis() {
      let numero = 0;
      let i;
      for (i = 0; i < this.notificaciones.length; i++) {
        if (this.notificaciones[i].readed === false){
          numero += 1;
        }
      }
      return numero;
    },
    notisIcon(){
      if (this.numNotis === 0) {
        return "notifications_none";
      } else {
        return "notifications_active";
      }
    },
    // @vuese
    // Título de la barra de navegación
    appTitle() {
      if (this.isAuthenticated) {
        this.appTitles = "Portal";
      } else {
        this.appTitles = "TFG";
      }
      return this.appTitles;
    },
    // @vuese
    // Enlace del título de la barra de navegación
    titleLink() {
      if (this.isAuthenticated) {
        return "/dashboard";
      } else {
        return "/";
      }
    },
    // @vuese
    // Comprueba si el usuario tiene sesión iniciada
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    // @vuese
    // Enlaces de la barra en función de si está autenticado o no
    menuItems() {
      if (this.isAuthenticated) {
        let notisIcon;
        if (this.numNotis === 0) {
          notisIcon = "notifications_none";
        } else {
          notisIcon = "notifications_active";
        }
        return [
          { title: "Panel", path: "/dashboard", icon: "dashboard" },
          {
            title: "Alertas",
            path: "/notifications",
            icon: notisIcon,
            numNotis: this.numNotis
          },
          { title: "Nuevo", path: "/new", icon: "add_box" },
          { title: "Perfil", path: "/profile?id="+this.$store.state.user.uid, icon: "person" }
        ];
      } else {
        return [
          { title: "Inicio", path: "/", icon: "home" },
          { title: "Registrarse", path: "/signup", icon: "face" },
          { title: "Iniciar sesión", path: "/signin", icon: "lock_open" }
        ];
      }
    }
  },
  methods: {
    // @vuese
    // Cerrar sesión
    userSignOut() {
      this.$store.dispatch("userSignOut");
    }
  }
};
</script>

<style>
  .signout {
    background: #F44336; /*Rojo de Vuetify*/
    color: white;
  }
</style>
